import type { Mood } from "../lib/types.ts";

type Props = {
  moods: Mood[];
  value: string | null;
  onChange: (slug: string) => void;
};

/**
 * Rejilla de estados de animo.
 *
 * La identidad la llevan el emoji y la etiqueta: el color es un acento
 * decorativo del estado seleccionado, nunca el unico portador del significado.
 */
export function MoodPicker({ moods, value, onChange }: Props) {
  return (
    <div className="field">
      <span className="field__label" id="mood-label">Estado de ánimo</span>
      <div className="moods" role="radiogroup" aria-labelledby="mood-label">
        {moods.map((mood) => {
          const selected = mood.slug === value;
          return (
            <button
              key={mood.slug}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`mood${selected ? " mood--on" : ""}`}
              style={{ ["--mood" as string]: mood.color }}
              onClick={() => onChange(mood.slug)}
            >
              <span className="mood__emoji" aria-hidden="true">{mood.emoji}</span>
              <span className="mood__label">{mood.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
